import axios from 'axios';

export default {
    fetchPleatingLists(offset, limit, filters = {}) {
        return axios.post('/pleatinglist/list/', {
            offset,
            limit,
            ...filters,
        });
    },
    fetchDetails(id, extended = false) {
        return axios.post('/pleatinglist/details', { id, extended });
    },
    done(id, done, isolateIntoNewPaintlist = false) {
        return axios.post('/pleatinglist/done/', {
            id,
            done,
            isolateIntoNewPaintlist,
        });
    },
    markFinished(id, employeeId) {
        return axios.post('/pleatinglist/markFinished/', {
            id,
            employeeId,
        });
    },
    remove(pleatingListId) {
        return axios.post('/pleatinglist/remove/', { pleatingListId });
    },
    previous(id) {
        return axios.post('/pleatinglist/previous', { id });
    },
    next(id) {
        return axios.post('/pleatinglist/next', { id });
    },
    updateDescription(id, description) {
        return axios.post('/pleatinglist/updateDescription', {
            id,
            description,
        });
    },
    updateSawn(pleatingListId, employeeId) {
        return axios.post('/pleatinglist/updateSawn/', {
            pleatingListId,
            employeeId,
        });
    },
    updateSawnForRecord(recordId, sawn) {
        return axios.post('/pleatinglist/updateSawnForRecord/', {
            recordId,
            sawn,
        });
    },
    fetchOverview(payload) {
        return axios.post('/pleatinglist/fetchOverview/', payload);
    },
    calculatePleating(productIds) {
        return axios.post('/pleatinglist/calculatePleating', { productIds });
    },
    idToNr(pleatingListId) {
        return axios.post('/pleatinglist/idToNr/', { pleatingListId });
    },
    fetchDataForPleatingWorkstation(pleatingListId) {
        return axios.get(
            `[API]/pleating-lists/${pleatingListId}/pleating-workstation-data`
        );
    },
    markProductRecordsAsSawn(pleatingListId, productId) {
        return axios.post(
            `[API]/pleating-lists/${pleatingListId}/mark-product-records-as-sawn`,
            { productId }
        );
    },
    unmarkProductRecordsAsSawn(pleatingListId, productId) {
        return axios.post(
            `[API]/pleating-lists/${pleatingListId}/unmark-product-records-as-sawn`,
            { productId }
        );
    },
};
